var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Cog8ToothIcon } from "@heroicons/react/24/outline";
import { useContext, useEffect } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { UserFilter } from "../../components/Filter/UserFilter/UserFilter";
import { UserModal } from "../../components/Modal/UserModal/UserModal";
import { UsersSettingsModal } from "../../components/Modal/UsersSettingsModal/UsersSettingsModal";
import { WPQTPageHeader } from "../../components/common/Header/Header";
import { CHANGE_USER_SETTINGS_MODAL_OPEN, SET_FULL_PAGE_LOADING, } from "../../constants";
import { LoadingContext } from "../../providers/LoadingContextProvider";
import { ModalContext } from "../../providers/ModalContextProvider";
import { UserContext } from "../../providers/UserContextProvider";
import { Page } from "../Page/Page";
import { AddUser } from "./components/AddUser/AddUser";
import { UserList } from "./components/UserList/UserList";
function UsersPage() {
    const { updateUsers } = useContext(UserContext);
    const { loadingDispatch } = useContext(LoadingContext);
    const { modalDispatch } = useContext(ModalContext);
    useEffect(() => {
        const updateUsersAsync = () => __awaiter(this, void 0, void 0, function* () {
            loadingDispatch({ type: SET_FULL_PAGE_LOADING, payload: true });
            yield updateUsers();
            loadingDispatch({ type: SET_FULL_PAGE_LOADING, payload: false });
        });
        updateUsersAsync();
    }, []);
    return (_jsxs(Page, { children: [_jsx(WPQTPageHeader, { description: __("Create and manage users", "quicktasker"), icon: _jsx(Cog8ToothIcon, { className: "wpqt-icon-gray wpqt-size-7 wpqt-cursor-pointer hover:wpqt-text-qtBlueHover", onClick: () => {
                        modalDispatch({
                            type: CHANGE_USER_SETTINGS_MODAL_OPEN,
                            payload: true,
                        });
                    } }), children: __("QuickTasker users page", "quicktasker") }), _jsx(AddUser, {}), _jsx(UserFilter, {}), _jsx(UserList, {}), _jsx(UsersSettingsModal, {}), _jsx(UserModal, {})] }));
}
export { UsersPage };
